module.exports = __webpack_public_path__ + "img/ghIcon1.16aaff04.png";